<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    :class="[{ 'search-item': $route.name === 'SSearchResultQuery' }]"
    class="temporary-position"
    data-cy="searchResultItem"
    :data-cy-type="
      getItemType(item).substring(5).replace('</div>', '').toLowerCase()
    "
  >
    <md-card
      class="snew-item-card"
      :class="[
        { lpCardSize: $route.name === 'landingPage' },
        { 'md-elevation-5': $route.name === 'landingPage' && !mouseEnter },
        { searchCardSize: $route.name === 'SSearchResultQuery' },
        { 'md-elevation-20': mouseEnter },
      ]"
      data-cy="lpItemPostBlock"
    >
      <div v-if="getTradeColor === 'tertiary'" class="card-header">
        <md-avatar class="little-header-avatar-give">
          <img
            src="../../../public/img/little-header-icons/item-header.png"
            alt="Item"
          />
        </md-avatar>
        <span class="md-title">Item</span>
        <img
          src="../../../public/img/item-give-card-header.png"
          alt="card-header-img"
          class="card-header-image"
        />
      </div>
      <div v-if="getTradeColor === 'offer'" class="card-header">
        <md-avatar class="little-header-avatar-receive">
          <img
            src="../../../public/img/little-header-icons/item-header.png"
            alt="Item"
          />
        </md-avatar>
        <span class="md-title">Item</span>
        <img
          src="../../../public/img/item-receive-card-header.png"
          alt="card-header-img"
          class="card-header-image"
        />
      </div>
      <md-card-header>
        <router-link :to="`/s-app/profile-page/${item.posterId}`">
          <SUserAvatar
            :myUser="item.user"
            size="small"
            :isProfileAvatar="false"
          />
        </router-link>

        <div class="md-title header-content">
          <div class="user-content-container">
            <div class="user-content">
              <span class="card-poster-name">
                <router-link
                  :to="`/s-app/profile-page/${item.posterId}`"
                  :data-cy="`linkPoster_item-${item.title}`"
                >
                  {{ getItemPosterName }}
                </router-link>
              </span>
              <span class="card-username">{{ getPosterUsername }}</span>
            </div>

            <div class="md-subhead posted-info">
              Posted
              <time class="posted-date" datetime="2017-03-24T18:18">{{
                getTimeAgo(item.createdAt)
              }}</time>
            </div>
          </div>

          <div
            @mouseenter="show = openOrCloseDropDown()"
            @mouseleave="show = false"
            :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
          >
            <dropdown-menu
              id="drop-dot"
              v-model="show"
              :right="true"
              transition="translate-fade-down"
              v-if="
                isItemFromUser &&
                (getItemAvailability(item) || !itemHaveRequests)
              "
              :class="[
                {
                  'dropdown-menu-profile': $route.name === 'SSearchResultQuery',
                },
              ]"
            >
              <md-button
                :md-ripple="false"
                md-elevation="0"
                class="md-icon-button dropdown-toggle menu-dot"
                :data-cy="`dotItemMenu-${item.title}`"
              >
                <md-icon class="more-vert-icon">more_vert</md-icon>
              </md-button>
              <div slot="dropdown" class="dot-drop">
                <router-link
                  class="dropdown-item"
                  :to="`/s-app/item-review?edit=true&item_id=${item.id}`"
                  v-if="!itemHaveRequests"
                >
                  <md-icon id="edit-icon">edit</md-icon>
                  <span>Edit</span>
                  <md-tooltip
                    md-direction="right"
                    class="s-tooltip tp-chat-position"
                    >Edit item</md-tooltip
                  >
                </router-link>
                <a
                  class="dropdown-item"
                  href="#"
                  v-if="getItemAvailability(item)"
                  @click.prevent="openModal(`#${deleteItemModalId}`)"
                  :data-cy="`deleteItemButton-${item.title}`"
                >
                  <md-icon id="delete-icon">delete</md-icon>
                  <span class="delete-button">Delete</span>
                  <md-tooltip
                    md-direction="right"
                    class="s-tooltip tp-chat-position"
                    >Delete item</md-tooltip
                  >
                </a>
              </div>
            </dropdown-menu>
          </div>
        </div>
      </md-card-header>
      <div class="card-image-parent" :class="[getTradeColor]">
        <md-card-media>
          <div
            class="image"
            :class="{ 'item-unavailable': !getItemAvailability(item) }"
          >
            <img
              @click="checkRoute()"
              :src="getItemImagePath(item)"
              alt="Item"
            />
          </div>
        </md-card-media>
      </div>

      <md-card-content>
        <div class="head">
          <div class="md-subhead item-subhead">
            <div class="item-card-title">
              <div
                class="poster-name-content mr-1"
                :class="[
                  { 'lp-poster-name-class': $route.name === 'landingPage' },
                ]"
              >
                <span class="poster-name">{{ getItemPosterName }}</span>
              </div>
              {{ wantText }}
              <span class="ml-1" :class="[getTradeColor]">{{
                getTradeType
              }}</span>
            </div>
            <div class="state-content">
              <div class="state">
                <span class="item-state">{{ getItemState }}</span>
              </div>
            </div>
          </div>
          <div class="md-title">
            <h5
              class="item-name"
              @click="checkRoute()"
              :data-cy="`linkItemDetails-${item.title}`"
            >
              {{ item.title }}
              <md-tooltip v-if="nameTooBig"
                md-direction="bottom"
                class="s-tooltip tp-trade-position"
              >
                {{ item.title }}
              </md-tooltip>
            </h5>
          </div>
        </div>
        <div class="item-description scroll" v-html="item.description"></div>

        <div>
          <div @click="checkRoute()">
            <div class="item-price" :class="[getActionsPositionClass]">
              <div class="free-content" v-if="isItemFree">
                <div class="free">
                  <span>Free</span>
                </div>
              </div>
              <div v-if="!paymentPointsAndCash">
                <div class="md-title points-option" v-if="item.points > 0">
                  {{
                    getItemPoints
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                  <img
                    class="mt-1 mr-1 ml-1"
                    src="/img/Polygon_7.svg"
                    alt="Swampum"
                    width="12"
                    height="12"
                  />
                </div>
                <div
                  class="md-title cash-option mr-2 higher-line"
                  v-if="item.cash > 0"
                >
                  {{ getItemCash | toCurrency }}
                </div>
              </div>
              <div class="md-title points-option" v-else>
                {{
                  getItemPoints.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                <img
                  class="mt-1 mr-1 ml-1"
                  src="/img/Polygon_7.svg"
                  alt="Swampum"
                  width="12"
                  height="12"
                />
              </div>
              <div class="one-row" v-if="paymentPointsAndCash">
                <span class="or-option ml-1 mr-1">or</span>
                <div class="md-title cash-option mr-2" v-if="item.cash > 0">
                  {{ getItemCash | toCurrency }}
                </div>
              </div>
            </div>
          </div>
          <div>
            <md-card-actions
              class="no-padding"
              v-if="!isItemFromUser && getItemAvailability(item) && itemRequestStatus == false"
            >
              <div class="mr-2">
                <SButtonMaterial
                  class="trade-item-btn"
                  buttonType="button"
                  :color="getTradeColor"
                  :class="[{ 'offer-item-class': getTradeText === 'offer' }]"
                  textColor="white"
                  iconColor="white"
                  iconLeftText="swap_horiz"
                  materialClass="dense"
                  :text="getTradeText"
                  @button="tradeItem()"
                  :data-cy="`itemTradeBtn-${item.title}`"
                />
                <md-tooltip
                  md-direction="bottom"
                  class="s-tooltip tp-trade-position"
                  >{{ getTradeTooltipText }}</md-tooltip
                >
              </div>
              <div>
                <SButtonMaterial
                  class="send-msg-item-btn"
                  buttonType="button"
                  :color="getTradeColor"
                  iconColor="white"
                  iconWithoutText="message"
                  materialClass="dense"
                  @button="openChat()"
                  :data-cy="`newItemChatButton-${item.title}`"
                />
                <md-tooltip
                  md-direction="bottom"
                  class="s-tooltip tp-chat-position"
                  >Chat</md-tooltip
                >
              </div>
            </md-card-actions>
            <md-card-actions
              class="no-padding"
              v-else-if="!isItemFromUser "
            >
              <div class="mr-2">
                <SButtonMaterial
                  class="item-requested-btn"
                  buttonType="button"
                  :color="getTradeColor"
                  :class="[{ 'offer-item-class': getTradeText === 'offer' }]"
                  textColor="white"
                  iconColor="white"
                  iconLeftText="hourglass_bottom"
                  materialClass="dense"
                  :disabled="true"
                  text="Currently unavailable"
                  @button="tradeItem()"
                  :data-cy="`itemTradeBtn-${item.title}`"
                />
                <md-tooltip
                  md-direction="bottom"
                  class="s-tooltip tp-trade-position situation-tooltip"
                  >{{ tooltipBtnText }} <br> Message {{ getPosterName(item) }} to check availability</md-tooltip
                >
              </div>
              <div>
                <SButtonMaterial
                  class="send-msg-item-btn"
                  buttonType="button"
                  :color="getTradeColor"
                  iconColor="white"
                  iconWithoutText="message"
                  materialClass="dense"
                  @button="openChat()"
                  :data-cy="`newItemChatButton-${item.title}`"
                />
                <md-tooltip
                  md-direction="bottom"
                  class="s-tooltip tp-chat-position"
                  >Chat</md-tooltip
                >
              </div>
            </md-card-actions>
          </div>
        </div>
        <md-card-actions
          class="no-padding"
          v-if="isItemFromUser && getItemAvailability(item)"
        >
          <div>
            <SButtonMaterial
              class="interested-item-btn"
              :md-ripple="false"
              buttonType="button"
              color="transparent"
              :textColor="getInterestedColor"
              :disabled="!itemHaveRequests"
              :iconColor="getInterestedColor"
              :iconLeftText="getIconName"
              :text="interestedText"
              @button="goToInterestedItem"
              borderColor="noBorder"
              materialClass="dense"
            />
          </div>
        </md-card-actions>
      </md-card-content>
    </md-card>
    <ModalTradeItem :item="item" />
    <ModalDeleteItem
      :item="itemWithRequests"
      :itemHaveRequests="itemHaveRequests"
      @deleteItem="$emit('deleteItem')"
    />
  </div>
</template>

<script>
import moment from "moment";
import DropdownMenu from "@innologica/vue-dropdown-menu";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import ModalTradeItem from "@/components/molecules/ModalTradeItem.vue";
import ModalDeleteItem from "@/material-components/molecules/ModalDeleteItem.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import itemType from "@/enum/item-type";
import requestSituation from "@/enum/request-situation";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import Global from "@/constants/Global";
export default {
  name: "SLendedItemMaterial",
  props: ["item"],
  mixins: [UserHelperVue, ItemHelperVue, ChatHelperVue],
  data() {
    return {
      show: false,
      reqSituation: requestSituation,
      mouseEnter: false,
      itemRequestStatus: false
    };
  },
  components: {
    DropdownMenu,
    SButtonMaterial,
    ModalTradeItem,
    ModalDeleteItem,
    SUserAvatar,
  },
  methods: {
    checkRoute() {
      if (this.isUserAuthenticated) {
        this.$router.push(`/s-app/item-details/${this.item.id}`);
      } else {
        this.$router.push(`/item-details-landing/${this.item.id}`);
      }
    },
    getTimeAgo(time) {
      return moment(time).fromNow();
    },
    openChat() {
      if (this.isUserAuthenticated) {
        this.$emit("openWindowPopup");
      } else {
        this.$router.push(`/s-app/item-details/${this.item.id}`);
      }
    },
    openModal(modal) {
      $(modal).modal("show");
    },
    tradeItem() {
      if (this.isUserAuthenticated) {
        this.openModal(`#${this.tradeItemModalId}`);
      } else {
        this.$router.push(`/s-app/item-details/${this.item.id}`);
      }
    },
    goToInterestedItem() {
      this.$router.push({
        path: `/s-app/item-details/${this.item.id}`,
        query: { interested: 1 },
      });
    },
    openOrCloseDropDown() {
      return !Global.checkDevice();
    },
  },
  computed: {
    getTradeColor() {
      switch (this.item.type) {
        case 3:
          return "tertiary";
        case 4:
          return "offer";
        default:
          return "";
      }
    },
    tooltipBtnText() {
      return "Borrowed by another user";
    },
    isItemFree() {
      return this.item.cash === 0 && this.item.points === 0;
    },
    tradeItemModalId() {
      return `trade-item-${this.item.id}`;
    },
    deleteItemModalId() {
      return `delete-item-${this.item.id}`;
    },
    getItemCash() {
      if (this.item.cash > 0) return this.item.cash;
      return "";
    },
    isItemFromUser() {
      if (!this.loggedUser) return false;
      return this.item.posterId === this.loggedUser.id;
    },
    getItemPosterName() {
      if (!this.isItemFromUser) return this.getUserName(this.item.user);
      return "You";
    },
    getPosterUsername() {
      if (this.item.user.username) return "@" + this.item.user.username;
      return "";
    },
    paymentPointsAndCash() {
      return this.item.cash > 0 && this.item.points > 0;
    },
    getItemPoints() {
      if (this.item.points > 0) return `${this.item.points}`;
      return "";
    },
    getTradeText() {
      const type = this.item.type;
      if (type === itemType.GIVE || type === itemType.LEND) return "request";
      else if (type === itemType.RECEIVE || type === itemType.BORROW)
        return "offer";
      else return "Trade item";
    },
    getTradeType() {
      if (this.item.type === itemType.GIVE) {
        return "GIVE";
      } else if (this.item.type === itemType.RECEIVE) {
        return "RECEIVE";
      } else if (this.item.type === itemType.LEND) {
        return "LEND";
      } else {
        return "BORROW";
      }
    },
    getItemState() {
      if (this.item.condition === 1) {
        return "New";
      } else if (this.item.condition === 2) {
        return "Like new";
      } else if (this.item.condition === 3) {
        return "Used";
      } else {
        return "Worn";
      }
    },
    itemWithRequests() {
      if (
        this.itemRequestsReceived === undefined ||
        this.itemRequestsReceived === null
      )
        return {};
      else {
        const getRequests = this.itemRequestsReceived.filter(
          (ir) => ir.itemId === this.item.id
        );
        return {
          ...this.item,
          requests: getRequests,
        };
      }
    },
    getTradeTooltipText() {
      const type = this.item.type;
      if (type === itemType.GIVE || type === itemType.LEND)
        return "Request from this poster";
      else if (type === itemType.RECEIVE || type === itemType.BORROW)
        return "Offer to this poster";
      else return "Trade item";
    },
    itemHaveRequests() {
      return this.numberOfRequestsOpen !== 0;
    },
    numberOfRequestsOpen() {
      let reqsOpen = 0;
      this.itemWithRequests.requests.forEach((request) => {
        if (request.situation === this.reqSituation.OPEN) reqsOpen++;
      });

      return reqsOpen;
    },
    getActionsPositionClass() {
      if (this.item.description === null || this.item.description === undefined)
        return;
      else {
        if (
          this.item.description.length > 80 ||
          (this.item.cash > 0 && this.item.points > 0)
        )
          return "long-description";
        return "short-description";
      }
    },
    wantText() {
      if (this.isItemFromUser) return "want to";
      return "wants to";
    },
    interestedText() {
      return this.numberOfRequestsOpen.toString();
    },
    getInterestedColor() {
      if (this.itemHaveRequests) return this.getTradeColor;
      return "disabled";
    },
    getIconName() {
      return this.itemHaveRequests ? "mood" : "mood_bad";
    },
    nameTooBig() {
      if (this.item.title.length > 20) return true;
      return false;
    },
  },
  async mounted() {
    this.itemRequestStatus = await this.getItemStatus(this.item.id)
  }
};
</script>

<style lang="scss" scoped>
.no-padding {
  padding: 0;
}
.snew-item-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 280px;
  max-width: 100%;
  height: 558px;
  border-radius: 4px;
  border: 1px solid $grey;
}

.snew-item-card .md-card-content {
  padding-bottom: 14px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.item-subhead {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  opacity: 1 !important;
}
.state {
  width: fit-content;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  font-weight: bold;
  border-radius: 12px;
  text-align: center;
  background-color: $dark;
  padding: 8px;
}
.item-state {
  white-space: nowrap;
}
.free {
  width: 56px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 15px;
  text-align: center;
  background-color: $free-color;
  font-weight: 500;
}
.md-card-media img {
  object-fit: contain;
  max-width: 100%;
  max-height: 200px;
}
.tertiary,
.offer {
  font-weight: bold;
}
.tertiary {
  color: $tertiary;
  border-color: $tertiary;
}
.offer {
  color: $offer;
  border-color: $offer;
}
.item-card-title {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 1.1) !important;
  display: flex;
}
.item-name {
  width: fit-content;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0.4rem !important;
  cursor: pointer;
}
.card-username {
  margin-left: 0.3rem;
  font-size: 11px;
  color: $grey;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.user-content-container {
  flex: 0 0 85%;
  max-width: 100%;
}
.user-content {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  flex-direction: column;
}
.posted-date,
.card-poster-name {
  font-weight: bold;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.posted-info {
  color: $black !important;
  visibility: hidden;
}

.header-content {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  max-width: 250px;
}
.md-card .md-title {
  line-height: 20px !important;
}
</style>

<style lang="scss" scoped>
#drop-dot .show {
  width: 245px !important;
}
#drop-dot a {
  color: $black !important;
}
#drop-dot span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}
#drop-dot a:active {
  background-color: transparent;
}
#edit-icon,
#delete-icon {
  margin-top: -2px;
  margin-right: 0.4em;
}
#edit-icon {
  color: $black;
}
#delete-icon,
.delete-button {
  color: $danger;
}
.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
.more-vert-icon,
.edit-color {
  color: $black !important;
}
.delete-color {
  color: $danger !important;
}
.item-price {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  max-width: 230px;
}
.long-description {
  margin-top: 0.2rem;
}
.short-description {
  margin-top: 1rem;
}
.cash-option,
.points-option {
  display: flex;
  align-items: flex-start;
  color: $black;
}
.md-card .md-title {
  font-size: 24px !important;
}
.one-row .cash-option {
  font-size: 16px !important;
  line-height: 20px !important;
}
div.md-title.cash-option.mr-2.higher-line {
  line-height: 24px !important;
}
.or-option {
  color: $dark;
  font-size: 0.95rem;
}
.send-msg-item-btn {
  min-width: 35px !important;
  min-height: 40px !important;
  border-radius: 4px;
  i {
    font-size: 25px !important;
  }
}
.interested-item-btn {
  min-width: 20px;
  margin-top: -2px !important;
}
.item-unavailable {
  filter: grayscale(100%);
}
.item-name,
.item-description {
  word-break: break-word !important;
}
.item-name {
  overflow: hidden;
  height: 28px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item-description {
  overflow: scroll;
  flex: 1 1 auto;
  max-height: 70px;
  display: flex;
  flex-direction: column;
}
.card-poster-name,
.card-poster-name a {
  color: $black !important;
}
.card-poster-name a:hover,
.item-name:hover {
  color: $primary !important;
}
.temporary-position {
  width: 100%;
  display: flex;
  justify-content: center;
}
.image {
  display: flex;
  justify-content: center;
  height: 169px;
  cursor: pointer;
}
.card-image-parent {
  display: flex;
  justify-content: center;
  border-style: ridge;
  margin: 0px 2.7%;
  border-width: thin;
}
@media screen and (max-width: 560px) {
  .user-content {
    width: unset;
  }
}
</style>

<style lang="scss" scoped>
.s-tooltip {
  margin-top: -6px;
  background: rgba(147, 147, 147, 0.4);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border-radius: 4px;
  color: $black;
  font-weight: 500;
}
.situation-tooltip {
  height: 42px;
  text-align: -webkit-center;
}
.poster-name-content {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 90px;
}
.lp-poster-name-class {
  max-width: 70px;
}
.dropdown-menu-profile {
  margin-left: -0.7rem;
}
.one-row {
  display: flex;
  align-items: baseline !important;
}
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
}
.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}
.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px !important;
  z-index: 2;
}
.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 75%;
}
.little-header-avatar-give {
  border-radius: 0;
  background-color: $tertiary !important;
}
.little-header-avatar-receive {
  border-radius: 0;
  background-color: $offer !important;
}

::-webkit-scrollbar-thumb {
  background: #757575;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background: white;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar:horizontal{
  display: none;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track-piece {
  width: 8px;
}
.scroll {
  display: block;
  width: 100%;
  overflow: scroll;
  height: 100%;
}
</style>

<style lang="scss">
.disabled-edit span,
.disabled-edit i {
  color: $dark !important;
}
.trade-item-btn {
  border-radius: 5px !important;
  width: 110px;
  height: 40px !important;
}
.item-requested-btn {
  border-radius: 5px !important;
  width: 15em;
  height: 40px !important;
}
.offer-item-class .button-content i {
  margin-right: 0.5rem;
}
.offer-item-class .button-content span {
  margin-right: 1rem;
}
.interested-item-btn {
  span {
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.interested-item-btn {
  border: none !important;
}
</style>
